import { GuarantorSelect } from "@/dentlab/src/forms/form-input-components/selects/guarantor.select";

import { useJobStore } from "@/dentlab/src/store/Jobs";

export const JobInfoGuarantorSelect: React.FC<{
	inputHeight?: number;
	validationError?: string | null;
}> = ({ inputHeight, validationError }) => {
	const { updateGuarantor, guarantorId } = useJobStore((state) => ({
		updateGuarantor: state.updateGuarantor,
		guarantorId: state.job?.guarantor_id,
	}));

	const handleGuarantorChange = (value: string | number | null) => {
		if (value) {
			updateGuarantor(value.toString());
		} else {
			updateGuarantor(null);
		}
	};

	return (
		<GuarantorSelect
			onChange={handleGuarantorChange}
			value={guarantorId ? guarantorId.toString() : ""}
			inputHeight={inputHeight}
			validationError={validationError}
		/>
	);
};
